module.exports = __webpack_public_path__ + "static/images/sprite-result.fd9806f.png";